export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8633.aaecd62b.jpg";